var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottomNav"},[_c('div',{staticClass:"bottomHurdle"},[_c('p',[_vm._v("地址："+_vm._s(_vm.pageInfo.address))]),_c('p',[_vm._v("备案号："+_vm._s(_vm.pageInfo.recordNumber)+" © 版权所有："+_vm._s(_vm.pageInfo.reserved)+" 隐私条款")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }